import { render, staticRenderFns } from "./StockTreePopup.vue?vue&type=template&id=24db2efc&scoped=true&"
import script from "./StockTreePopup.vue?vue&type=script&lang=js&"
export * from "./StockTreePopup.vue?vue&type=script&lang=js&"
import style0 from "./StockTreePopup.vue?vue&type=style&index=0&id=24db2efc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24db2efc",
  null
  
)

export default component.exports